import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Content, Title, Factor } from './styles';

interface ConversionFactorTooltipProps {
  factorKey: string;
}

export function ConversionFactorTooltip({
  factorKey,
}: Readonly<ConversionFactorTooltipProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <Content>
      <Title>{t('fatorDeConversao')}</Title>
      <Factor>{t(factorKey)}</Factor>
    </Content>
  );
}
